let klAjax = true


document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('minicart-header')) {
    customElements.define('minicart-header', class MiniCartHeader extends HTMLElement {
      constructor() {
        super()

        this.closeCart()
      }

      closeCart() {
        this.querySelectorAll('.close-cart').forEach(item => {
          item.addEventListener('click', () => {
            document.querySelector('#cart-icon-bubble').click()
          })
        })
      }
    })
  }
})

window.cart = {
  addToCart() {
    const btn = document.querySelector('[data-buy-button]')
    btn.classList.add('free-gift-loading')
    const id = document.querySelector('.product__atc input').getAttribute('data-variant-id')
    CartJS.addItem(id)

    function addedToCart() {
      fetch(`${window.location.origin}/cart.js`)
      .then(res => res.clone().json().then(data => {
        var cart = {
          total_price: data.total_price/100,
          $value: data.total_price/100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price/100,
          items: data.items
        }
        if (klAjax) {
            _learnq.push(['track', 'Added to Cart', cart]);
            klAjax = false;
          }
      }))
    };

    $(document).on('cart.requestComplete', () => {
      addedToCart()
      document.querySelector('#quickbuy__modal > div').click()
      document.querySelector('#minicart__button').checked = true
    })
  }
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', class CartItem extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.minicart__trash').addEventListener('click', (event) => {
        this.querySelector('.minicart__trash').classList.add('free-gift-loading')

        CartJS.removeItem(this.querySelector('.minicart__trash').getAttribute('data-line'))
      })

      if (this.querySelector('.quantity--input__decr')) {
        this.querySelector('.quantity--input__input').addEventListener('change', () => {
          this.updateQuantity()
        })
        this.querySelector('.quantity--input__incr').addEventListener('click', () => {
          this.querySelector('input').stepDown()
          this.updateQuantity()
        })
        this.querySelector('.quantity--input__decr').addEventListener('click', () => {
          this.querySelector('input').stepUp()
          this.updateQuantity()
        })
      }
    }

    timeout = null

    updateQuantity() {
      if (this.timeout) {
        return
      }

      this.timeout = setTimeout(() => {
        this.querySelector('.minicart__trash').classList.add('free-gift-loading')
        CartJS.updateItem(this.querySelector('.minicart__trash').getAttribute('data-line'), this.querySelector('input').value)
        this.timeout = null
      }, 300)
    }
  })
}

